import { AdminMessage } from "@components/atoms/AdminMessage"
import { Eyebrow } from "@components/atoms/Eyebrow"
import { HubspotForm } from "@components/atoms/HubspotForm"
import { Appear } from "@components/motion/Appear"
import { getTranslation } from "@utils/Translations"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Event Form",
  tags: ["#page"],
}

export default defineBlock("section/event-form", (props) => {
  return (
    <Appear className="event-form flex w-maxContentW mx-auto gap-8 my-9 md:px-6">
      <div className="w-full bg-charcoal text-white rounded-lg px-6 py-6 md:px-9 md:py-7 flex flex-col md:flex-row gap-10 md:gap-8 items-start justify-between">
        <div className="w-full flex flex-col gap-8 md:gap-7">
          <Eyebrow className="shrink-0" autoPlay>
            <EditableText
              as="span"
              store="eyebrow"
              plainText
              placeholder={getTranslation("meetWithUs", "Meet with us")}
              defaultValue={getTranslation("meetWithUs", "Meet with us")}
            />
          </Eyebrow>
          <div className={cn("w-full [&_h3]: flex flex-col gap-4")}>
            <EditableText
              as="h3"
              store="title"
              className="type-header-2-xl my-0"
              plainText
              placeholder="Enter an optional title"
            />
            <EditableText
              as="p"
              store="description"
              className="type-body-m my-0"
              placeholder="Enter an optional description"
            />
          </div>
        </div>

        <div className="w-full md:w-1/2 shrink-0">
          {props.hubspotForm ? (
            <HubspotForm formId={props.hubspotForm} />
          ) : (
            <AdminMessage>Select a form in the side panel</AdminMessage>
          )}
        </div>
      </div>
    </Appear>
  )
})
